import { render, staticRenderFns } from "./ContainerSingleExercise.vue?vue&type=template&id=e2563762&scoped=true"
import script from "./ContainerSingleExercise.vue?vue&type=script&lang=js"
export * from "./ContainerSingleExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2563762",
  null
  
)

export default component.exports